module.exports = __webpack_public_path__ + "img/Mountain.17ffdc72.png";